function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "1+27";


//////////////////
// WEBPACK FOOTER
// ./redevelopment/statistics/statisticsOpenedInv ^\.\/.*$
// module id = 1+27
// module chunks = 0